import { createRouter, createWebHashHistory } from 'vue-router'
import layout from '@/layout'
import store from '@/store'
import permissionAdmin from './modules/permission/permissionAdmin'

import permissionRole from './modules/permission/permissionRole'
import permissionMark from './modules/permission/permissionMark'
import AdminLog from './modules/other/adminLog'

import News from './modules/news/index'
import ConfigOther from './modules/config/index'
import InfoUser from './modules/info/user/index'
import InfoOrder from './modules/info/order/index'
import InfoMessage from './modules/info/message/index'

/**
 * 私有路由表 需要有权限才能访问
 */
export const privateRoutes = [
  InfoUser,
  InfoOrder,
  InfoMessage,
  News,
  ConfigOther,
  // 管理员列表
  permissionAdmin,
  // 角色管理
  permissionRole,
  // 权限管理
  permissionMark,
  // 日志
  AdminLog
]
/**
 * 公开路由表 不需要登录 就能访问的页面
 */
export const publicRoutes = [
  {
    path: '/login',
    component: () => import('@/views/login/index')
  },
  {
    path: '/bindWx',
    component: () => import('@/views/login/bindwx')
  },
  {
    path: '/',
    // 注意：带有路径“/”的记录中的组件“默认”是一个不返回 Promise 的函数
    component: layout,
    redirect: '/index',
    children: [
      // 个人中心
      {
        path: '/index',
        name: 'index',
        component: () => import('@/views/index/index'),
        meta: {
          title: 'profile',
          icon: 'home'
        }
      },
      // 404 页面
      {
        path: '/404',
        name: '404',
        component: () => import('@/views/error_page/404')
      },
      // 401 页面
      {
        path: '/401',
        name: '401',
        component: () => import('@/views/error_page/401')
      }

    ]
  }

]

export function resetRouter () {
  if (store.getters.adminInfo && store.getters.adminInfo.permission && store.getters.adminInfo.permission.menus) {
    const menus = store.getters.adminInfo.permission.menus

    menus.forEach(menu => {
      router.removeRoute(menu)
    })
  }
}

const router = createRouter({
  history: createWebHashHistory(),
  routes: publicRoutes
})

export default router
